import { v4 as uuidv4 } from "uuid";

export class RequestToSend {
  id: string;
  title: string;
  cacheMethod: Function;
  successAction: (value: any) => void;
  parameters: any;
  body: any;
  requestsToInvalidate: string[];

  constructor(
    title: string,
    cacheMethod: any,
    successAction: (value: any) => void,
    parameters: any,
    body: any,
    requestsToInvalidate: string[]
  ) {
    this.id = uuidv4();
    this.title = title;
    this.cacheMethod = cacheMethod;
    this.body = body;
    this.successAction = successAction;
    this.parameters = parameters;
    this.requestsToInvalidate = requestsToInvalidate;
  }
}
